<template>
  <div class="fail-wrap">
    <div class="fail-content">
      <img v-if="fetchStatus === 2004" src="@/assets/img/img_delivery.png" />
      <i v-else-if="!fetchStatus" class="fal fa-circle-notch fa-spin"></i>
      <img v-else src="@/assets/img/img_bubble_exclamation.png" />
      <div v-html="msg"></div>
    </div>
    <div class="call">
      <img src="@/assets/img/ic_call_mypage.svg" /> 배송문의 1544-4805
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: null,
      imgUrl: null
    };
  },
  computed: {
    fetchStatus() {
      const status = this.code;
      if (!this.code) {
        this.msg = `위치를 불러오는 중입니다`;
      } else if (this.code === 2004) {
        this.msg = `주문하신 물품은 디버 협력사를<br/> 통해 안전하게 배송중입니다.`;
      } else if (this.code === 2003) {
        this.msg = `픽업요청시간 <span style="color : #2EA3FF; font-weight : 500">1시간 전</span>부터<br/>파트너 위치를 조회하실 수 있습니다.`;
      } else {
        this.msg = `파트너 위치정보를<br/> 불러오는데 실패하였습니다.`;
      }

      return status;
    }
  },
  created() {},
  props: ["code"]
};
</script>
<style scoped>
.fail-wrap {
  background-color: var(--gray-100);
  height: 580px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 40px;
  border-radius: 8px;
}

.fail-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 48px;

  font-size: 18px;
  font-weight: 300;
  line-height: 26px;
}

.fail-content img {
  width: 100px;
  height: 100px;
}

.blue-bold {
  color: var(--primary-400);
}

.call {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  gap: 4px;
  color: var(--gray-500);
}

i {
  font-size: 100px;
  color: var(--primary-400);
  font-weight: 600;
}

@media all and (max-width: 1023px) {
  .modal-container {
    font-size: 20px;
    line-height: 28px;
  }
}
</style>
